import Show from "Components/Show/Show";
import React, { useState } from "react";
import SendReceiptPopup from "../PaymentDetailsInfo/SendReceiptPopup";
import api from "http";
import { ErrorHandlingMessage } from "Utils/ErrorHandlingMessage";
import { LuMail, LuEye, LuRotateCcw } from "react-icons/lu";
import Spinner from "Common/Spinner";
import { PAYMENT_METHODS } from "Common/Constants";
import { toast } from "react-toastify";
import PaymentRefundPopup from "Popups/PaymentRefundPopup/PaymentRefundPopup";
import ClaimTimeLinePopup from "Popups/ClaimTimeLinePopup/ClaimTimeLinePopup";
import AddAttachmentPopup from "Popups/AddAttachmentPopup/AddAttachmentPopup";
import ViewPatientStatementPopup from "Popups/ViewPatientStatementPopup/ViewPatientStatementPopup";
import ThreeDotsIcon from "SVGS/ThreeDotsIcon";
import Dropdown from "Common/DropDown/Dropdown";
import { Tooltip } from "react-tooltip";
import AddPatientPaymentMemoPopup from "Popups/AddPatientPaymentMemoPopup/AddPatientPaymentMemoPopup";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import CopyToClipboard from "Common/CopyToClipboard ";

const tooltipContent =
  "Posted payment cannot be refunded. Apply a payment reversal first, then issue the refund";
const PaymentDetailsInfoNewHeader = ({
  paymentId,
  paymentModel,
  state,
  getPaymentMain,
  viewAddAttachmentPopup,
  setViewAddAttachmentPopup,
  setValidationModel,
  setPaymentModel,
  handleAttachmentChange,
  handleRemoveAttachment,
  openViewAttachment,
  handleApplyPayment,
  handlePaymentChange,
  validationModel,
}) => {
  const [showPaymentReceiptPopup, setShowPaymentReceiptPopup] = useState(false);
  const [showAddMemoPopup, setShowAddMemoPopup] = useState(false);
  const [loader, setLoader] = useState(false);
  const [viewPaymentRefundPopup, setViewPaymentRefundPopup] = useState(false);
  const [viewDetailPopup, setViewDetailPopup] = useState({
    status: false,
    row: null,
  });
  const [viewReceiptPdf, setViewReceiptPdf] = useState({
    type: "",
    value: "",
  });
  const [openReceiptPopup, setOpenReceiptPopup] = useState(false);

  //  ************* Payment Receipt function ************
  const openPaymentReceiptPopup = () => {
    setShowPaymentReceiptPopup(true);
  };
  const closePaymentReceiptPopup = () => {
    setShowPaymentReceiptPopup(false);
  };
  const openPaymentReceipt = async () => {
    const isMethodCashOrCheck = [
      PAYMENT_METHODS.CASH,
      PAYMENT_METHODS.CHECK,
    ].includes(paymentModel.paymentMethod);
    try {
      setLoader(true);
      if (isMethodCashOrCheck) {
        const response = await api.get(
          `${process.env.REACT_APP_TC_PMS}/api/PatientPayment/GeneratePaymentReceipt/${paymentId}`
        );
        let pdfBase64 = response.data.dataModel.base64String;
        setViewReceiptPdf({ type: "base64", value: pdfBase64 });
        setOpenReceiptPopup(true);
      } else {
        const response = await api.get(
          process.env.REACT_APP_TC_PMS +
          `/api/PatientPayment/FindPaymentReceipt/${paymentId}`
        );
        window.open(response.data.dataModel.receiptPresignedUrl, "_blank");
      }
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoader(false);
    }
  };

  const closePaymentReceipt = () => {
    setOpenReceiptPopup(false);
  };
  //  ************* Refund Payment function ************
  const handleRefundPayment = async (value) => {
    try {
      setLoader(true);
      const payload = {
        paymentMainId: paymentId,
        amount: value.amount,
        reason: value.reason,
        reasonNote: value.reasonNote,
      };
      const response = await api.post(
        `${process.env.REACT_APP_TC_PMS}/api/PatientPayment/RefundPaymentIntent`,
        payload
      );
      setViewPaymentRefundPopup(false);
      getPaymentMain();
      toast.success(response.data.responseMessage);
    } catch (error) {
      ErrorHandlingMessage(error);
    } finally {
      setLoader(false);
    }
  };
  const openPaymentRefundPopup = () => {
    setViewPaymentRefundPopup(true);
  };
  const closePaymentRefundPopup = () => {
    setViewPaymentRefundPopup(false);
  };

  //  ************* View Detail function ************
  const handleOpenViewDetail = () => {
    setViewDetailPopup({
      status: true,
      row: paymentId,
    });
  };
  const handleCloseViewDetail = () => {
    setViewDetailPopup({
      status: false,
      row: null,
    });
  };

  //  ************* Add Attachment function ************
  const openAddMemo = () => {
    setShowAddMemoPopup(true);
  };
  const closeAddMemo = () => {
    setShowAddMemoPopup(false);
  };
  const openAddAttachment = () => {
    setViewAddAttachmentPopup(true);
  };
  const closeAddAttachment = () => {
    setValidationModel((prevModel) => ({
      ...prevModel,
      errorPaymentAttachment: null,
      notes: null,
    }));
    setPaymentModel((prev) => ({
      ...prev,
      paymentAttachment: [],
    }));
    setViewAddAttachmentPopup(false);
  };
  const disableRefundTooltip = !(
    paymentModel.paymentMethod === PAYMENT_METHODS.CREDIT_CARD &&
    paymentModel.paidAmount > 0 &&
    paymentModel.postedAmount === 0 &&
    !paymentModel.isPosted
  );
  const viewDetailObjectData = [
    { type: "Check/EFT", object: "paymentMainLog" },
    { type: "Claim", object: "visitPaymentLog" },
    { type: "Service Line", object: "visitChargePaymentLog" },
    {
      type: "Remit Codes Adjustment",
      object: "visitChargePaymentAdjustmentLog",
    },
    { type: "Provider Adjustment", object: "providerPaymentAdjustmentLog" },
  ];
  const historyLog = {
    paymentMainId: null,
    paymentMainLog: [],
    providerPaymentAdjustmentLog: null,
    stripePaymentHistoryLog: null,
    stripePaymentRefundHistoryLog: null,
    visitChargePaymentAdjustmentLog: null,
    totalRecord: 0,
    visitChargePaymentLog: [],
    visitPaymentLog: [],
    visitAdditionalInfoLog: null,
  };
  return (
    <div className="px-6 py-6 border-b border-slate-200">
      {loader && <FullPageLoader  allowFullScreen/>}
      <Tooltip
        id={`refundPayment-tooltip`}
        style={{ zIndex: 99, maxWidth: 220 }}
      />
      <Show when={showAddMemoPopup}>
        <AddPatientPaymentMemoPopup
          onClose={closeAddMemo}
          paymentModel={paymentModel}
          handlePaymentChange={handlePaymentChange}
          handleApplyPayment={handleApplyPayment}
        />
      </Show>
      <Show when={openReceiptPopup}>
        <ViewPatientStatementPopup
          Heading="View Payment Receipt"
          onClose={closePaymentReceipt}
          ViewPdf={viewReceiptPdf}
        />
      </Show>
      <Show when={showPaymentReceiptPopup}>
        <SendReceiptPopup
          paymentMainId={paymentId}
          onClose={closePaymentReceiptPopup}
          paidAmount={paymentModel.paidAmount}
          receivedDate={paymentModel.receivedDate}
          patientInfo={{
            email: state.patientInfo?.patientEmail,
            phone: state.patientInfo?.patientPhoneNumber,
          }}
          isCashOrCheck={[PAYMENT_METHODS.CASH, PAYMENT_METHODS.CHECK].includes(
            paymentModel.paymentMethod
          )}
        />
      </Show>
      <Show when={viewPaymentRefundPopup}>
        <PaymentRefundPopup
          required
          paidAmount={Number(paymentModel.paidAmount).toFixed(2)}
          onCancel={closePaymentRefundPopup}
          onConfirm={(value) => handleRefundPayment(value)}
        />
      </Show>
      {viewAddAttachmentPopup && (
        <AddAttachmentPopup
          onClose={closeAddAttachment}
          paymentModel={paymentModel}
          handleAttachmentChange={handleAttachmentChange}
          handleRemoveAttachment={handleRemoveAttachment}
          openViewAttachment={openViewAttachment}
          handleApplyPayment={handleApplyPayment}
          handlePaymentChange={handlePaymentChange}
          validationModel={validationModel}
        />
      )}
      {viewDetailPopup.status && (
        <ClaimTimeLinePopup
          onClose={handleCloseViewDetail}
          objectData={viewDetailObjectData}
          History={historyLog}
          Id={viewDetailPopup.row}
          APi="/api/Payment/FindPaymentAuditLog"
          keyName="paymentmainid"
          createdDate={paymentModel.receivedDate}
        />
      )}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <h1 className="text-2xl font-bold text-slate-900">
            Payment# {<CopyToClipboard textToCopy={paymentId} >{paymentId}</CopyToClipboard>}
          </h1>
          <span
            className={`inline-flex items-center px-3 py-1 mt-1 rounded text-xs font-semibold  ${
              paymentModel.isUnpostable
                ? "bg-gray-100 text-gray-700"
                : paymentModel.isPosted
                  ? "bg-green-100 text-green-700"
                  : "bg-amber-100 text-amber-700"
            }`}
          >
            {paymentModel.isUnpostable
              ? "Unpostable"
              : paymentModel.isPosted
                ? "Posted"
                : "Unposted"}
          </span>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={openPaymentReceiptPopup}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors bg-white border rounded-lg text-slate-700 hover:text-slate-900 border-slate-300 hover:bg-slate-50"
          >
            <LuMail className="w-4 h-4" />
            Send Receipt
          </button>
          <button
            disabled={loader}
            onClick={openPaymentReceipt}
            className="flex items-center gap-2 px-4 py-2 text-sm font-medium transition-colors bg-white border rounded-lg text-slate-700 hover:text-slate-900 border-slate-300 hover:bg-slate-50"
          >
            {loader ? <Spinner /> : <LuEye className="w-4 h-4" />}
            View Receipt
          </button>
          {![PAYMENT_METHODS.CHECK, PAYMENT_METHODS.CASH].includes(
            paymentModel.paymentMethod
          ) && (
              <>
                <button
                  onClick={openPaymentRefundPopup}
                  disabled={disableRefundTooltip}
                  data-tooltip-hidden={!disableRefundTooltip}
                  data-tooltip-id="refundPayment-tooltip"
                  data-tooltip-content={tooltipContent}
                  className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 transition-colors border border-red-600 rounded-lg hover:text-white hover:bg-red-600 disabled:bg-gray-200 disabled:border-gray-200 disabled:cursor-not-allowed disabled:text-gray-400 disabled:from-gray-200 disabled:to-gray-200 disabled:shadow-none disabled:grayscale"
                >
                  <LuRotateCcw className="w-4 h-4" />
                  Refund
                </button>
              </>
            )}
          <Dropdown>
            <Dropdown.Button>
              <ThreeDotsIcon
                size={20}
                className="mx-[-5px] transition-colors rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-50"
              />
            </Dropdown.Button>
            <Dropdown.Menu>
              <Dropdown.MenuItem
                className="group rdx_item"
                onSelect={() => openPaymentReceipt()}
              >
                View Receipt
              </Dropdown.MenuItem>
              <Dropdown.MenuItem
                className="group rdx_item"
                onSelect={() => openPaymentReceiptPopup()}
              >
                Send Receipt
              </Dropdown.MenuItem>
              {![PAYMENT_METHODS.CHECK, PAYMENT_METHODS.CASH].includes(
                paymentModel.paymentMethod
              ) && (
                  <Dropdown.MenuItem
                    disabled={disableRefundTooltip}
                    className="group rdx_item"
                    data-tooltip-hidden={!disableRefundTooltip}
                    data-tooltip-id="refundPayment-tooltip"
                    data-tooltip-content={tooltipContent}
                    onSelect={() => openPaymentRefundPopup()}
                  >
                    Refund
                  </Dropdown.MenuItem>
                )}
              <Dropdown.MenuItem
                className="group rdx_item"
                onSelect={() => handleOpenViewDetail()}
              >
                View Logs
              </Dropdown.MenuItem>
              <Dropdown.MenuItem
                className="group rdx_item"
                onSelect={() => openAddMemo()}
              >
                Add Memo
              </Dropdown.MenuItem>
              <Dropdown.MenuItem
                className="group rdx_item"
                onSelect={() => openAddAttachment()}
              >
                Add Attachment
              </Dropdown.MenuItem>
            </Dropdown.Menu>
          </Dropdown>
          {/* <Dropdown>
                            <Dropdown.Button>
                                <ThreeDotsIcon size={20} className="mx-[-5px] transition-colors rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-50" />
                            </Dropdown.Button>
                            <Dropdown.Menu >
                            <Dropdown.MenuItem className="group rdx_item" onSelect={() =>openPaymentReceipt()}>
                                <div className='flex items-center gap-2'><MailIcon className="w-4 h-4" />View Receipt </div>
                            </Dropdown.MenuItem>
                            <Dropdown.MenuItem className="group rdx_item" onSelect={() => openPaymentReceiptPopup()}>
                                <div className='flex items-center gap-2'><LuEye className="w-4 h-4" />Send Receipt</div>
                            </Dropdown.MenuItem>
                            <Dropdown.MenuItem disabled={disableRefundTooltip === true} className="group rdx_item"
                             data-tooltip-hidden={!disableRefundTooltip} data-tooltip-id="refundPayment-tooltip" data-tooltip-content="Refunds cannot be processed on posted payments. To enable the refund option, Payment Method is Credit Card or Check. please first reverse the payment using the Reversal Payment action."
                             onSelect={() => openPaymentRefundPopup()}>
                                <div className='flex items-center gap-2'><LuRotateCcw className="w-4 h-4" />Refund</div>
                            </Dropdown.MenuItem>
                            <Dropdown.MenuItem className="group rdx_item"onSelect={() => handleOpenViewDetail()}>
                                <div className='flex items-center gap-2'><LuScrollText className="w-4 h-4" />View Logs</div>
                            </Dropdown.MenuItem>
                            <Dropdown.MenuItem className="group rdx_item" onSelect={() => openAddAttachment()}>
                                <div className='flex items-center gap-2'><LuPaperclip className="w-4 h-4" />Add Attachment</div>
                            </Dropdown.MenuItem>
                            </Dropdown.Menu>
                        </Dropdown> */}
        </div>
      </div>
    </div>
  );
};

export default PaymentDetailsInfoNewHeader;
